import React from "react";

export const TermsAndConditions = () => {
  return (
    <div className="fs-5 text-justify">
      {/* Banner */}
      <div className="py-5 bg-dark text-light text-center">
        <div className="container">
          <h1 className="highlight-title text-gold display-4 mb-3">
            Terms & Conditions
          </h1>
          <p className="lead">
            Please read these terms and conditions carefully before using our website and services.
          </p>
        </div>
      </div>

      {/* Body Content */}
      <div className="bg-light py-5">
        <div className="container bg-white p-4 p-md-5 rounded shadow-sm">
          <p className="text-muted mb-4">
            Last Updated: June 19, 2026
          </p>

          <section className="mb-4">
            <h3 className="fw-bold text-gold mb-3">1. Agreement to Terms</h3>
            <p>
              By accessing our website at <span className="fw-bold">Procoatify India LLP</span> (referred to as "we", "us", or "our") or using our powder coating services, you agree to be bound by these Terms and Conditions and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this site.
            </p>
          </section>

          <section className="mb-4">
            <h3 className="fw-bold text-gold mb-3">2. Service Description</h3>
            <p>
              Procoatify India LLP operates Pune's largest aluminum coating plant. We specialize in high-precision, eco-friendly powder coating services for architectural, engineering, automobile, electrical, and real estate applications. All specifications, lead times, and quotes provided on the site or via contact channels are subject to final contract verification.
            </p>
          </section>

          <section className="mb-4">
            <h3 className="fw-bold text-gold mb-3">3. User Consent and Notifications</h3>
            <p>
              By submitting your details via our Contact Us forms, you explicitly authorize and consent to receive communication from Procoatify India LLP and its affiliates. This includes, but is not limited to:
            </p>
            <ul className="ps-4 mb-3">
              <li>Transactional and promotional SMS/messages.</li>
              <li>WhatsApp updates regarding quotes, schedules, and orders.</li>
              <li>RCS and other mobile information messages.</li>
              <li>Emails and customer service phone calls.</li>
            </ul>
            <p>
              You acknowledge that you may opt out of promotional messages at any time by contacting our customer care line.
            </p>
          </section>

          <section className="mb-4">
            <h3 className="fw-bold text-gold mb-3">4. Intellectual Property Rights</h3>
            <p>
              The materials contained on this website (including text, images, logos, graphics, and code) are protected by applicable intellectual property and copyright laws. Permission is granted to temporarily view the materials on our website for personal, non-commercial transitory viewing only.
            </p>
          </section>

          <section className="mb-4">
            <h3 className="fw-bold text-gold mb-3">5. Limitation of Liability</h3>
            <p>
              In no event shall Procoatify India LLP or its partners be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on our website, even if we have been notified orally or in writing of the possibility of such damage.
            </p>
          </section>

          <section className="mb-4">
            <h3 className="fw-bold text-gold mb-3">6. Modifications and Revisions</h3>
            <p>
              We may revise these terms of service at any time without notice. By using this website, you are agreeing to be bound by the then current version of these Terms and Conditions.
            </p>
          </section>

          <section className="mb-4">
            <h3 className="fw-bold text-gold mb-3">7. Governing Law</h3>
            <p>
              Any claim relating to Procoatify India LLP's website or services shall be governed by the laws of India, without regard to its conflict of law provisions, and shall be subject to the exclusive jurisdiction of the courts in Pune, Maharashtra.
            </p>
          </section>

          <div className="mt-5 border-top pt-4">
            <p className="mb-1"><strong>Procoatify India LLP</strong></p>
            <p className="mb-1">Gat No. 313, Gaud Dara Road, Khedshivapur, Pune - 412205</p>
            <p className="mb-1">Phone: +91-8600500400 / +91-9960852623</p>
            <p className="mb-0">Email: procoatifyindia@gmail.com</p>
          </div>
        </div>
      </div>
    </div>
  );
};
